module.exports = __webpack_public_path__ + "img/logo_adn83.55ee16ed.png";